import { mq } from 'utilities/breakpoints'
import { classes } from 'constants'

class VideoMower {
    constructor(container) {
        this.onSwitchToMobile = this.onSwitchToMobile.bind(this)

        this.container = container
        this.video = container.querySelector('.js-video')
        this.pauseVideoTime = this.video.duration * 1000 / 2 // to milliseconds half

        this.startContainer = document.querySelector('.js-video-start')
        this.endContainer = document.querySelector('.js-video-end')

        this.loadVideo()

        this.mediaMobileBreakpoint = window.matchMedia(mq['SM_ONLY'])
        this.mediaMobileBreakpoint.addListener(this.onSwitchToMobile)
        this.onSwitchToMobile()
    }

    static getTranslateY(y = 0) {
        return `translateY(${y})`
    }

    static getOffsetTop(elem) {
        let offsetTop = 0
        do {
            if (!isNaN(elem.offsetTop)) {
                offsetTop += elem.offsetTop
            }

            elem = elem.offsetParent
        } while (elem)
        return offsetTop
    }

    static switchVideosAppearance(show, hide) {
        show.classList.remove(classes.HIDDEN)
        hide.classList.add(classes.HIDDEN)
    }

    onSwitchToMobile() {
        if (this.mediaMobileBreakpoint.matches) {
            this.startContainer.style.transform = VideoMower.getTranslateY()
            this.endContainer.style.transform = VideoMower.getTranslateY()
            this.playHalfVideo()
            this.video.addEventListener('pause', () => {
                this.mobileLooping = setTimeout(
                    () => this.playHalfVideo(),
                    7000
                )
            })
        } else {
            this.video.pause()
            this.setVideoOnStart()
            clearTimeout(this.mobileLooping)
        }
    }

    loadVideo() {
        this.video.load()
    }

    playHalfVideo() {
        this.playVideo()
        setTimeout(() => {
            this.video.pause()
        }, this.pauseVideoTime)
    }

    playVideo() {
        // w/o it throws DOMException from the 1st section to the 2nd
        setTimeout(() => {
            this.video.play()
        }, 0)
    }

    playBackwardsVideo() {
        this.video.play()
    }

    setVideoOnStart() {
        if (this.video.currentTime) this.video.currentTime = 0
    }

    setVideoOnHalf() {
        this.video.currentTime = this.pauseVideoTime / 1000
    }

    moveDown() {
        const offsetTopStart = VideoMower.getOffsetTop(this.startContainer)
        const offsetTopEnd = VideoMower.getOffsetTop(this.endContainer)
        const y = `${offsetTopEnd - offsetTopStart}px`
        this.startContainer.style.transform = VideoMower.getTranslateY(y)
        this.endContainer.style.transform = VideoMower.getTranslateY()
    }

    moveUp() {
        const offsetTopStart = VideoMower.getOffsetTop(this.startContainer)
        const offsetTopEnd = VideoMower.getOffsetTop(this.endContainer)
        const y = `-${offsetTopEnd - offsetTopStart}px`
        this.startContainer.style.transform = VideoMower.getTranslateY()
        this.endContainer.style.transform = VideoMower.getTranslateY(y)
    }
}

export default VideoMower
